import StackGrid from "./components/stack/stack-grid";

export default function HomePage() {
  return <StackGrid />;
}
